
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { getFormatDate } from "@/common/utils";
import config from "@/config";
import { pageViewUnit } from "@/config";
import { isCollection, addCollection, deleteCollection } from "@/api/policy";
import Share from "vue-social-share";
import cookie from "js-cookie";
import "vue-social-share/dist/client.css";
@Component({
  name: "Policy",
  components: { Share },
})
export default class Policy extends Vue {
  @Action("policy/addReadView") private addReadView: any;
  @Action("policy/getImgDetail") private getPolicyData: any;
  pageViewUnit = pageViewUnit;
  pageData: any = {};
  textId: any = this.$route.query.textId;
  file: any = [];
  shareConfig: any = { show: false };
  isCollection: Boolean = false;
  created() {
    const textId = this.textId;
    // this.addReadView(textId);
    this.getData();
  }
  download({ url }: any) {
    window.open(url);
  }
  getFileName(url){
    if (!url) return "文件.pdf";
    // 截取最后一个 / 后面的内容 就是文件名
    return url.substring(url.lastIndexOf("/") + 1);
  }
  getData() {
    if (cookie.get("accessToken")) {
      isCollection({
        type: "policy",
        id: this.textId,
      }).then((res) => {
        this.isCollection = res.data.result;
      });
    }
    this.getPolicyData(this.textId).then(({ code, result, msg }: any) => {
      if (code === 200) {
        let data = result;
        this.pageData = data;
        this.shareConfig = {
          show: true,
          url: config.h5Url + "#/policy/details?id=" + this.$route.query.textId,
          source: "黄石政策计算器",
          title: data.title,
          image: data.withPicturesUrl,
          description: data.labels,
          sites: ["wechat", "qzone", "weibo"],
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper:
            "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
        };
      }
    });
  }
  adEvent() {
    if (cookie.get("accessToken")) {
      addCollection({
        type: "policy",
        id: this.textId,
      }).then((res) => {
        this.$message.success("收藏成功");
        this.isCollection = true;
      });
    } else {
      this.$message.warning("请先登录!");
    }
  }
  delEvent() {
    deleteCollection({
      type: "policy",
      id: this.textId,
    }).then((res) => {
      this.$message("取消收藏");
      this.isCollection = false;
    });
  }
}
